export const sortAscending = (byKey: string) => (o1: any, o2: any) => {
  return o1[byKey] - o2[byKey]
}

export const sortDescending = (byKey: string) => (o1: any, o2: any) => {
  return o2[byKey] - o1[byKey]
}
